<template>
	<div id="Carousel">
		<el-carousel :interval="4000" type="card" height="450px">
		    <el-carousel-item v-for="(item,index) in images" :key="index">
		      <el-image style="width: 100%; height: 100%;" :src="item">
						<div slot="placeholder" class="image-slot">
							加载中<span class="dot">...</span>
						</div>
		      </el-image>
		    </el-carousel-item>
		  </el-carousel>
	</div>
</template>

<script>
	export default{
		name:'Carousel',
		data(){
			return{
				images:['http://itbx.cc/images/swp.png','http://itbx.cc/images/swp2.png','http://itbx.cc/images/swp2.png']
			}
		},
		methods:{
		}
	}
</script>

<style scoped>
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
</style>